import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadImageUrlById } from "../../../store/uploadFile";
import uploadFileService from "../../../services/uploadFile.service";

const ImageView = (props) => {
  const { imageLabel, imageURL, onChangeImageUrl, height, width, ...others } =
    props;
  /// test image

  // const dispatch = useDispatch();
  // const { loadImageUrl } = useSelector((state) => state.uplaodFile);
  const [imageUrlTemp, setImageUrlTemp] = React.useState(null);

  const getData = async (id) => {
    try {
      const data = await uploadFileService.loadImage2(id);
      setImageUrlTemp(data);
      return data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return message;
    }
  };

  // / test image

  // / test image
  // const handleOnloadImage = async (id) => {
  //   dispatch(loadImageUrlById({ id: id }));
  // };

  // React.useEffect(() => {
  //   setImageUrlTemp(loadImageUrl);
  // }, [loadImageUrl]);

  React.useEffect(() => {
    // handleOnloadImage(others.fileId);
    getData(others.fileId);
  }, [others.fileId]);

  // test image

  return (
    <div>
      <span>{imageLabel}</span>
      {/* <div>URL:</div>
      <input
        type="text"
        sx={{ height: "20px" }}
        placeholder="Image URL"
        value={others.fileId ? imageUrlTemp : imageURL}
        onChange={onChangeImageUrl}
        style={{ width: "100%" }}
      /> */}
      <img
        height={height}
        width={width}
        src={others.fileId ? imageUrlTemp : imageURL}
        alt="image"
      ></img>
    </div>
  );
};

export default ImageView;
